import React from 'react';

const Uncheckbox = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <path d="M12.5 0C5.60722 0 0 5.60722 0 12.5C0 19.3928 5.60722 25 12.5 25C19.3928 25 25 19.3928 25 12.5C25 5.60722 19.3928 0 12.5 0Z" fill="url(#paint0_linear)" />
      <path d="M17.1016 15.6301C17.5089 16.0375 17.5089 16.6958 17.1016 17.1032C16.8985 17.3063 16.6319 17.4084 16.365 17.4084C16.0984 17.4084 15.8317 17.3063 15.6286 17.1032L12.4985 13.9728L9.3683 17.1032C9.16517 17.3063 8.89852 17.4084 8.63188 17.4084C8.36504 17.4084 8.09839 17.3063 7.89526 17.1032C7.48804 16.6958 7.48804 16.0375 7.89526 15.6301L11.0256 12.5L7.89526 9.36984C7.48804 8.96243 7.48804 8.3042 7.89526 7.89679C8.30267 7.48957 8.96089 7.48957 9.3683 7.89679L12.4985 11.0271L15.6286 7.89679C16.036 7.48957 16.6942 7.48957 17.1016 7.89679C17.5089 8.3042 17.5089 8.96243 17.1016 9.36984L13.9713 12.5L17.1016 15.6301Z" fill="white" />
    </g>
    <defs>
      <linearGradient id="paint0_linear" x1="25" y1="-5.96046e-06" x2="-1.45914" y2="1.65369" gradientUnits="userSpaceOnUse">
        <stop stopColor="#5936E3" />
        <stop offset="1" stopColor="#6956B5" />
      </linearGradient>
    </defs>
  </svg>
);

export default Uncheckbox;
